import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isVinEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('vin'),
)

export default isVinEnabledSelector
